let _lightboxContext;

export const setLightboxContext = (context) => {
  _lightboxContext = context;
};

export const getLightboxContext = () => _lightboxContext;


// WEBPACK FOOTER //
// ./js/modules/privates/contextService.es6